import * as React from 'react'
import { HashFields, HiddenField, Label, Select } from 'react-rails-form-helpers'
import * as API from '../lib/api'

interface IProps {
  selectedProfileId?: number
  paymentProfiles: API.IPaymentProfile[]
  handleAddNewCardClick: () => void
}

export class PaymentProfileForm extends React.Component<IProps, object> {
  public render() {
    const { selectedProfileId } = this.props

    return (
      <>
        <HashFields name={`payment_profile`}>
          <Label htmlFor="id">Credit/Debit Card</Label>
          <Select name="id" onChange={this.handleOnChange} defaultValue={selectedProfileId}>
            {this.paymentProfiles()}
          </Select>
        </HashFields>

        <HiddenField name="payment_type" value="payment_profile" />
      </>
    )
  }

  private handleOnChange = (e: React.FormEvent<HTMLSelectElement>) => {
    const { handleAddNewCardClick } = this.props
    const value = e.currentTarget.value

    if (value === 'new-card') {
      handleAddNewCardClick()
    }
  }

  private paymentProfiles() {
    const { paymentProfiles } = this.props
    const paymentProfileOptions: JSX.Element[] = []

    paymentProfiles.map((paymentProfile) => {
      const { id, name } = paymentProfile

      paymentProfileOptions.push(
        <option key={id} value={id}>{name}</option>,
      )
    })

    paymentProfileOptions.push(
      <option key="new-card" value="new-card">Add New Card</option>,
    )

    return paymentProfileOptions
  }
}
